<template>
  <div class="page" >
    你访问的页面不翼而飞了...
  </div>
</template>

<script>
export default {
  name: 'miniApp',
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/miniapp/error/notFound.vue